import { defineMessages } from 'react-intl'

const scope = `procurify.accounts-payable.features.duplicate-statement-item.presenters.DuplicateStatementItemPresenter`

export default defineMessages({
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  genericErrorMessage: {
    id: `${scope}.genericErrorMessage`,
    defaultMessage: 'Unable to duplicate the statement item.',
  },
})
